import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, object = user
  const [ready, setReady] = useState(false);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("hr_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const u = await api.me();
      setUser(u);
    } catch {
      localStorage.removeItem("hr_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const data = await api.login({ email, password });
    localStorage.setItem("hr_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, display_name) => {
    const data = await api.register({ email, password, display_name });
    localStorage.setItem("hr_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("hr_token");
    setUser(false);
  };

  const isAuthed = !!user;

  return (
    <AuthContext.Provider value={{ user, ready, isAuthed, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
